import React, { useEffect, useState } from 'react';
import { Button } from '@saleshandy/design-system';
import { ChevronRight, ShoppingCart } from '@saleshandy/icons';
import classNames from 'classnames';

import {
  OverlayTooltip,
  Placement,
} from '../../../../../../../../shared/design-system/components/overlay';

type PurchasePhoneNumberFooterProps = {
  selectedNumbersCount: number;
  totalPrice: string;
  isNextButtonDisabled: boolean;
  isNextButtonLoading: boolean;
  onNextButtonClick: () => void;
  nextButtonText: string;
  shouldShow: boolean;
  onViewCartClick?: () => void;
};

const PurchasePhoneNumberFooter: React.FC<PurchasePhoneNumberFooterProps> = ({
  selectedNumbersCount,
  totalPrice,
  isNextButtonDisabled,
  isNextButtonLoading,
  onNextButtonClick,
  nextButtonText,
  shouldShow,
  onViewCartClick,
}) => {
  const [showInDOM, setShowInDOM] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleViewCart = () => {
    if (onViewCartClick) {
      onViewCartClick();
    }
  };

  useEffect(() => {
    if (shouldShow) {
      setShowInDOM(true);
      setIsVisible(true);
    } else {
      setIsVisible(false);
      setShowInDOM(false);
    }
  }, [shouldShow]);

  if (!showInDOM) return null;

  const footerClassName = classNames('purchase-phone-number__footer', {
    visible: isVisible,
  });

  const ViewCartButton: React.FC<{ className?: string }> = ({ className = '' }) => (
    <div
      className={`view-cart-btn ${className}`}
      {...(selectedNumbersCount > 0 && {
        onClick: handleViewCart,
        onMouseDown: (e: React.MouseEvent) => e.preventDefault(),
      })}
    >
      <div className="view-cart-btn--icon">
        <ShoppingCart />
      </div>
      <div className="view-cart-btn--text">
        <span>
          {selectedNumbersCount === 1
            ? '1 Number'
            : `${selectedNumbersCount} Numbers`}
        </span>
      </div>
    </div>
  );

  return (
    <div className={footerClassName}>
      <div className="purchase-phone-number__footer--container">
        <div className="purchase-phone-number__footer--left">
          {selectedNumbersCount > 0 ? (
            <OverlayTooltip text="View Cart" placement={Placement.Top}>
              <div>
                <ViewCartButton />
              </div>
            </OverlayTooltip>
          ) : (
            <ViewCartButton className="noNumbers" />
          )}

          {selectedNumbersCount > 0 && (
            <>
              <div className="purchase-phone-number__footer--left--divider" />
              <div className="purchase-phone-number__footer--left--total">
                <span>{totalPrice}</span>
              </div>
            </>
          )}
        </div>
        <div className="purchase-phone-number__footer--right">
          <Button
            disabled={isNextButtonDisabled}
            isLoading={isNextButtonLoading}
            onClick={onNextButtonClick}
            loadingText={nextButtonText}
            icon={ChevronRight}
            iconPlacement="right"
            className="purchase-phone-number__footer--cta"
          >
            {nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PurchasePhoneNumberFooter;

